// Copyright 2016 Sorama B.V.

export class Api {
    static authority: string = SORAMA_IDENTITY_WEB_URL;
    static identityUri: string = Api.authority + "/connect";
    static computeUri: string = SORAMA_COMPUTE_WEB_URL;
    static baseUri: string = SORAMA_WEBAPI_URL;

    static businessUnit: string = Api.baseUri + "/BusinessUnits";
    static licenseHolder: string = Api.baseUri + "/LicenseHolders";
    static license: string = Api.baseUri + "/Licenses";
    static licenseKind: string = Api.baseUri + "/LicenseKinds";
    static licenseBundle: string = Api.baseUri + "/LicenseBundles";
    static licenseBundleKind: string = Api.baseUri + "/LicenseBundleKinds";
    static creditsHolder: string = Api.baseUri + "/CreditsHolders";
    static creditsPack: string = Api.baseUri + "/CreditsPacks";
    static creditsBalance: string = Api.baseUri + "/CreditsBalances";
    static representatives: string = Api.baseUri + "/Representatives";
    static representativeGroups: string = Api.baseUri + "/RepresentativeGroups";
    static representativeGroupTemplates: string = Api.baseUri + "/RepresentativeGroupTemplates";
    static storage: string = Api.baseUri + "/Storage";
    static permissions: string = Api.baseUri + "/Permissions";
    static users: string = Api.baseUri + "/Users";
    static projects: string = Api.baseUri + "/Projects";
    static measurement: string = Api.baseUri + "/Measurements";
    static computedMeasurements: string = Api.computeUri + "/Measurements";
    static status: string = Api.baseUri + "/Status";
    static media: string = Api.baseUri + "/Media";
    static timelineEntries: string = Api.baseUri + "/TimelineEntries";
    static canvases: string = Api.baseUri + "/Canvases";
    static canvasMediaObjectLinks: string = Api.baseUri + "/CanvasMediaObjectLinks";
    static projectCanvasCollections: string = Api.baseUri + "/ProjectCanvasCollections";
    static specialMeasurementsFromFile: string = Api.baseUri + "/Measurements/SpecialMeasurements";
    static as2MeasurementsFromFile: string = Api.baseUri + "/Measurements/As2";
    static sorMeasurementsFromFile: string = Api.baseUri + "/Measurements/Sor";
    static sorxMeasurementsFromFile: string = Api.baseUri + "/Measurements/UploadSorXFileFromFile";
    static sorMetadataFromFile: string = Api.baseUri + "/Measurements/SorMetadata"; //The sor measurement placeholder

    static mediaImages: string = Api.media + "/Images";
    static mediaVideos: string = Api.media + "/Videos";
    static mediaFiles: string = Api.media + "/Files";
    static as2Files: string = Api.measurement + "/as2/Measurement";
    static as2MediaFiles: string = Api.media + "/as2/Media/";

    static mediaTextboxes: string = Api.media + "/TextBoxes";

    static analysis: string = Api.computeUri + "/Analysis";
    static exports: string = Api.computeUri + "/Exports";
    static video: string = Api.computeUri + "/Video";

    static guid: string = Api.baseUri + "/Guids";
    static account: string = Api.baseUri + "/Account";
    static passwordRequest: string = Api.authority + "/api/PasswordRequest";
    static userManager: string = Api.authority + "/api/User";

    static hardware: string = Api.baseUri + "/Hardware";
    static hardwareInformation: string = Api.baseUri + "/HardwareInformation";
    static microphoneArrayRack = "MicrophoneArrayRacks";
    static microphoneArray = "MicrophoneArrays";
    static motionDevice = "MotionDevices";
    static frontEndConnectorDevice = "FrontEndConnectors";
    static webcamDevice = "WebCams";
    static frontEnds = "FrontEnds";

    static firmware: string = Api.baseUri + "/Firmware";
}
